import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { AddressValidationTemplate } from 'themes/modules/order/pages';
import { BaasicSelect, Loader, BaasicInput, DatePicker, BaasicCheckbox } from 'core/components';

const EditOrderTemplate = ({
	t,
	editOrderViewStore,
	editOrderViewStore: {
		loading,
		form,
		onBack,
		stateOptions,
		onSelectChange,
		debouncedCountrySearch,
		isCountryLoading,
		countryOptions,
		onMenuClose,
		datePickerFormat,
		displayAddressValidation,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			{!displayAddressValidation && (
				<form className="ReactModal__form" onSubmit={form.onSubmit}>
					<div className="ReactModal__header">
						<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.EDITMODAL.TITLE')}</h3>
					</div>
					<div className="ReactModal__body">
						<div className="spc--bottom--sml">
							<DatePicker field={form.$('shipByDate')} format={datePickerFormat} />
						</div>
						<BaasicInput field={form.$('buyerName')} className="fs-mask" />
						<BaasicInput autoFocus field={form.$('shippingAddress1')} className="fs-mask" />
						<BaasicInput field={form.$('shippingAddress2')} className="fs-mask" />
						<BaasicInput field={form.$('shippingCity')} />
						<BaasicInput field={form.$('shippingZipCode')} />
						<BaasicInput field={form.$('buyerPhone')} className="fs-mask" />
						<BaasicSelect
							field={form.$('shippingCoreCountry')}
							value={form.$('shippingCoreCountry').value}
							onChange={value => onSelectChange(value, form.$('shippingCoreCountry'))}
							options={countryOptions.slice()}
							onInputChange={debouncedCountrySearch}
							onMenuClose={() => onMenuClose()}
							isLoading={isCountryLoading}
							className="spc--bottom--sml flex--grow--1"
						/>
						<BaasicSelect
							field={form.$('shippingCoreCountryState')}
							value={form.$('shippingCoreCountryState').value}
							options={stateOptions}
							onChange={value => onSelectChange(value, form.$('shippingCoreCountryState'))}
							className="spc--bottom--sml flex--grow--1"
						/>
					</div>
					<div className="ReactModal__footer">
						<button className="btn btn--med btn--primary spc--right--sml spc--bottom--sml" type="submit">
							{t('SAVE')}
						</button>
						<button className="btn btn--med btn--secondary spc--bottom--sml" type="button" onClick={onBack}>
							{t('BACK')}
						</button>
					</div>
				</form>
			)}
			{displayAddressValidation && (
				<AddressValidationTemplate viewStore={editOrderViewStore} form={editOrderViewStore.form} t={t} />
			)}
		</section>
	);
};

export default defaultTemplate(EditOrderTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/EditOrderTemplate.jsx